import { memo } from "react"
import { Box, Container, Heading, Stack, SimpleGrid } from "@chakra-ui/react"
import { CustomLink } from "@app/components/Link"
import { useRoutes } from "@app/hooks/useRoutes"
import { FeaturedBrandItem } from "./FeaturedBrandItem"

const FeaturedBrands: React.FC<GatsbyTypes.SanitySectionFeaturedBrands> = ({ link, title, bgColor, brands }) => {
  const { urlResolver } = useRoutes()
  const resolvedLink = urlResolver(link)

  return (
    <Box bgColor={bgColor} py={[6, 8]}>
      <Container>
        <Stack direction={["column", "row"]} justifyContent="space-between" alignItems={["flex-start", "flex-end"]}>
          <Heading as="p" fontSize="3xl" lineHeight={1}>
            {title}
          </Heading>
          <CustomLink to={resolvedLink?.url} variant="underline">
            {resolvedLink?.title}
          </CustomLink>
        </Stack>
        <SimpleGrid pt={[6, 4]} columns={[1, 2, 4]} columnGap={[0, 4]} rowGap={[10, 4]}>
          {brands?.map(brand => (
            <FeaturedBrandItem key={brand?._key} {...brand} />
          ))}
        </SimpleGrid>
        <Box display={["block", "none"]} mt={10}>
          <CustomLink to={resolvedLink?.url} variant="underline">
            {resolvedLink?.title}
          </CustomLink>
        </Box>
      </Container>
    </Box>
  )
}

export default memo(FeaturedBrands)
